export enum SoftwareEscrowRequestChangesRoutesEnum {
  Agreement = 'agreement',
  Beneficiary = 'beneficiary',
  Depositor = 'depositor',
  Technical = 'technical',
  Deposits = 'deposits',
}
